var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "vx-row" }, [
      _c(
        "div",
        { staticClass: "vx-col lg:w-3/5 w-full" },
        [
          _c(
            "vx-card",
            { staticClass: "mb-4" },
            [
              _c(
                "div",
                { staticClass: "flex justify-between items-center mb-3" },
                [
                  _c("div", [
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.$t("my_fees.title"))),
                    ]),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("my_fees.subtitle"))),
                    ]),
                  ]),
                  _vm.current && _vm.current.plan && _vm.current.plan.is_default
                    ? _c(
                        "vs-chip",
                        {
                          staticClass: "text-base",
                          attrs: { color: "primary" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("fee_plans.default")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.current && _vm.current.plan
                ? _c("div", [
                    _c("div", { staticClass: "mb-3" }, [
                      _c("span", { staticClass: "font-semibold" }, [
                        _vm._v(_vm._s(_vm.current.plan.name)),
                      ]),
                      _vm.current.version
                        ? _c("small", { staticClass: "text-muted ml-2" }, [
                            _vm._v(
                              " v" +
                                _vm._s(_vm.current.version.version) +
                                " · " +
                                _vm._s(
                                  _vm.$t("fee_plans.effective_since", {
                                    date: _vm.$utils.format.date(
                                      _vm.current.version.effective_from
                                    ),
                                  })
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "table",
                      {
                        staticClass: "w-full",
                        staticStyle: { "font-size": ".95rem" },
                      },
                      [
                        _c("thead", [
                          _c("tr", { staticClass: "text-left text-muted" }, [
                            _c("th", { staticClass: "pb-1" }, [
                              _vm._v(_vm._s(_vm.$t("my_fees.what_you_sell"))),
                            ]),
                            _c("th", { staticClass: "pb-1" }, [
                              _vm._v(_vm._s(_vm.$t("my_fees.what_you_pay"))),
                            ]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.current.rules, function (rule) {
                            return _c(
                              "tr",
                              { key: rule.id, staticClass: "border-top" },
                              [
                                _c("td", { staticClass: "py-2" }, [
                                  _vm._v(_vm._s(_vm.ruleScopeLabel(rule))),
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "py-2" },
                                  [
                                    rule.pricing_mode === "FLAT"
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "font-semibold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.rateLabel(
                                                    rule.fee_percent,
                                                    rule.fee_fixed_cents
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _vm._l(rule.tiers, function (tier) {
                                            return _c(
                                              "div",
                                              {
                                                key: tier.id,
                                                staticClass: "mb-1",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "font-semibold":
                                                        tier.id ===
                                                        rule.current_tier_id,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.tierThresholdLabel(
                                                            tier
                                                          )
                                                        ) +
                                                        " → " +
                                                        _vm._s(
                                                          _vm.rateLabel(
                                                            tier.fee_percent,
                                                            tier.fee_fixed_cents
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    tier.id ===
                                                    rule.current_tier_id
                                                      ? _c(
                                                          "vs-chip",
                                                          {
                                                            staticClass:
                                                              "text-sm ml-1",
                                                            attrs: {
                                                              color: "success",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "my_fees.you_are_here"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          }),
                                          rule.next_tier &&
                                          _vm.current.position.tiers_enabled
                                            ? _c(
                                                "div",
                                                { staticClass: "mt-1" },
                                                [
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-muted",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.nextTierLabel(
                                                            rule.next_tier
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                  ],
                                  2
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm.loaded
                ? _c(
                    "b-alert",
                    {
                      staticClass: "p-1",
                      attrs: { show: "", variant: "warning" },
                    },
                    [_c("small", [_vm._v(_vm._s(_vm.$t("fee_plans.no_plan")))])]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.current && _vm.current.position
            ? _c(
                "vx-card",
                { staticClass: "mb-4" },
                [
                  _c("h4", { staticClass: "mb-3" }, [
                    _vm._v(_vm._s(_vm.$t("my_fees.month_position"))),
                  ]),
                  _c("div", { staticClass: "vx-row" }, [
                    _c("div", { staticClass: "vx-col sm:w-1/2 w-full" }, [
                      _c("small", { staticClass: "text-muted d-block" }, [
                        _vm._v(_vm._s(_vm.$t("my_fees.month_gmv"))),
                      ]),
                      _c(
                        "span",
                        { staticClass: "text-xl font-semibold hb-money" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatCents(_vm.current.position.gmv_cents)
                            )
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "vx-col sm:w-1/2 w-full" }, [
                      _c("small", { staticClass: "text-muted d-block" }, [
                        _vm._v(_vm._s(_vm.$t("my_fees.month_sales"))),
                      ]),
                      _c("span", { staticClass: "text-xl font-semibold" }, [
                        _vm._v(_vm._s(_vm.current.position.sales_count)),
                      ]),
                    ]),
                  ]),
                  !_vm.current.position.tiers_enabled
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "p-1 mt-2 mb-0",
                          attrs: { show: "", variant: "info" },
                        },
                        [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("my_fees.tiers_disabled_hint"))
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "mb-4" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-primary", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/financial/fees")
                    },
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "ListIcon" },
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("my_fees.see_statement"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "vx-col lg:w-2/5 w-full" },
        [
          _c(
            "vx-card",
            [
              _c("h4", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.$t("my_fees.simulator"))),
              ]),
              _c("small", { staticClass: "text-muted d-block mb-3" }, [
                _vm._v(_vm._s(_vm.$t("my_fees.simulator_hint"))),
              ]),
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("fee_plans.simulator_amount") } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { prepend: "R$" } },
                    [
                      _c("b-form-input", {
                        attrs: { type: "number", min: "0", step: "0.01" },
                        on: { change: _vm.simulate },
                        model: {
                          value: _vm.simulator.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.simulator, "amount", _vm._n($$v))
                          },
                          expression: "simulator.amount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("fee_plans.product_type") } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.typeOptions },
                    on: { change: _vm.simulate },
                    model: {
                      value: _vm.simulator.product_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.simulator, "product_type", $$v)
                      },
                      expression: "simulator.product_type",
                    },
                  }),
                ],
                1
              ),
              _vm.simulator.result
                ? _c(
                    "div",
                    { staticClass: "border-top pt-3" },
                    [
                      _vm.simulator.result.has_plan
                        ? [
                            _c(
                              "div",
                              { staticClass: "flex justify-between mb-1" },
                              [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("my_fees.simulator_gross"))
                                  ),
                                ]),
                                _c("small", { staticClass: "hb-money" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatCents(
                                        _vm.simulator.result.amount_cents
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "flex justify-between mb-1" },
                              [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("fee_plans.simulator_fee"))
                                  ),
                                ]),
                                _c("small", { staticClass: "hb-money" }, [
                                  _vm._v(
                                    " − " +
                                      _vm._s(
                                        _vm.formatCents(
                                          _vm.simulator.result.fee_amount_cents
                                        )
                                      ) +
                                      " (" +
                                      _vm._s(_vm.simulator.result.fee_percent) +
                                      "%"
                                  ),
                                  _vm.simulator.result.fee_fixed_cents
                                    ? _c("span", [
                                        _vm._v(
                                          " + " +
                                            _vm._s(
                                              _vm.formatCents(
                                                _vm.simulator.result
                                                  .fee_fixed_cents
                                              )
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(") "),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-between border-top pt-1",
                              },
                              [
                                _c("span", { staticClass: "font-medium" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("my_fees.simulator_you_get"))
                                  ),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font-semibold text-success hb-money",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCents(
                                          _vm.simulator.result.net_amount_cents
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _c(
                            "b-alert",
                            {
                              staticClass: "p-1 mb-0",
                              attrs: { show: "", variant: "info" },
                            },
                            [
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.$t("my_fees.simulator_no_plan"))
                                ),
                              ]),
                            ]
                          ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }